<template>
  <div class="flex-column flex-grow-1 text-right pl-1 mb-1">
    <div v-if="showShippingCost">
      <sf-text>
        {{ $t('order.shippingCosts') }}
        {{ formatMoneyShowZeroPrice(cartInfo.shippingCost, false) }}
      </sf-text>
    </div>
    <div>
      <sf-text v-if="showMinimumOrderSurcharge">
        {{ $t('order.quantitySurcharge') }}
        {{ formatMoneyShowZeroPrice(cartInfo.quantitySurcharge, false) }}
      </sf-text>
    </div>
    <div>
      <sf-text>
        {{
          cartInfo.vatPercent === 0
            ? $t('order.inEuTotalTax', [
                getVatRateText(cartInfo.vatPercent, portalSettings),
                zeroTaxFormatted
              ])
            : grossPortal
              ? $t('order.inclTotalTax', [
                  getVatRateText(cartInfo.vatPercent, portalSettings),
                  formatMoneyShowZeroPrice(cartInfo.totalTax, false)
                ])
              : $t('order.exclTotalTax', [
                  getVatRateText(cartInfo.vatPercent, portalSettings),
                  formatMoneyShowZeroPrice(cartInfo.totalTax, false)
                ])
        }}
      </sf-text>
    </div>
    <div>
      <sf-title v-if="bigSum">
        {{ 'Σ ' + formatMoneyShowZeroPrice(cartInfo.totalCost, false) }}
      </sf-title>
      <sf-text v-else>
        {{ 'Σ ' + formatMoneyShowZeroPrice(cartInfo.totalCost, false) }}
      </sf-text>
    </div>
  </div>
</template>

<script setup lang="ts">
import SfText from '@/components/text/SfText.vue'
import SfTitle from '@/components/text/SfTitle.vue'
import { getVatRateText } from '@/modules/portalSettings/helpers'
import usePortalSettings from '@/modules/portalSettings/usePortalSettings'
import { formatMoneyShowZeroPrice } from '@/modules/product/helpers'
import { CartInfo } from '@/types/index'
import { storeToRefs } from 'pinia'
import { computed, PropType, ref } from 'vue'

const props = defineProps({
  cartInfo: {
    type: Object as PropType<CartInfo>,
    required: true
  },
  grossPortal: {
    type: Boolean,
    required: true
  },
  isSupplierCart: {
    type: Boolean,
    required: true
  },
  bigSum: {
    type: Boolean,
    default: false
  }
})
const { portalSettings } = storeToRefs(usePortalSettings())

const zeroTaxFormatted = ref<string>(
  formatMoneyShowZeroPrice({ value: 0, currency: props.cartInfo.totalTax.currency }, false)
)

const showShippingCost = computed(() => {
  if (props.isSupplierCart && portalSettings.value.shippingCostsOnlyApplyOncePerCart) {
    return false
  }
  return props.cartInfo.shippingCost && props.cartInfo.shippingCost.value
})

const showMinimumOrderSurcharge = computed(() => {
  if (props.isSupplierCart && portalSettings.value.minimumOrderSurchargesOnlyApplyOncePerCart) {
    return false
  }
  return props.cartInfo.quantitySurcharge && props.cartInfo.quantitySurcharge.value
})
</script>
